
import { DELETE_API, GET_API, POST_API, PUT_API } from '../../Functionalities/APIs'

export const ManageInnerCategory = async (e, data, keyword, params) => {
  // e.preventDefault()
  const path = "/items/innercategory/";
  // void 0

  if (keyword == "get") {
    // void 0

    let result = GET_API("", params, path);
    // void 0

    return await result.then((result) => {
      // void 0
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }

  if (keyword == "add") {
    //alert("Add worked");
    var fdata = new FormData();
    fdata.append("name", data.name);
    // fdata.append("bg_image", data.bg_image);
    fdata.append("icon", data.icon);
    fdata.append("is_active", data.is_active);
    fdata.append("is_blocked", data.is_blocked);
    fdata.append("inner_category", data.inner_category);

    let result = POST_API(fdata, "", path);

    return await result.then((result) => {
      // void 0
      if (result) {
        // void 0
        return result;
      } else {
        return 0;
      }
    });
  }

  if (keyword == "update") {
    // void 0
    // void 0
    var fdata = new FormData();
    fdata.append("id", data.id);
    fdata.append("name", data.name);
    fdata.append("bg_image", data.bg_image);
    fdata.append("icon", data.icon);
    fdata.append("is_active", data.is_active);
    fdata.append("is_blocked", data.is_blocked);
    fdata.append("inner_category", data.inner_category);

    let result = PUT_API(fdata, "", path);
    // void 0
    // return 0
    return await result.then((result) => {
      // void 0
      if (result) {
        // void 0
        return result;
      } else {
        return 0;
      }
    });
  }
  if (keyword == "delete") {
    //alert("delete worked");
    let result = DELETE_API("", params, path);
    // void 0

    return await result.then((result) => {
      // void 0
      if (result) {
        // void 0
        return result;
      } else {
        return 0;
      }
    });
  }
};
